import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import Users from '../pages/Users';
import Items from '../pages/Items';
import ItemCategories from '../pages/Items/Category';
import Analytics from '../pages/Analytics';
import UserActivityAnalytics from '../pages/Analytics/UserActivity';
import Settings from '../pages/Settings';
import Profile from '../pages/Profile';
import AccountSettings from '../pages/AccountSettings';
import ProtectedRoute from './ProtectedRoute';
import { getRoutePermissions } from './routePermissions';
import Login from '../pages/Login/index';
import ResetPassword from '../pages/ResetPassword/index';
import NotFound404 from '../components/NotFound404';
import Country from '../pages/Location/Country';
import State from '../pages/Location/State';
import City from '../pages/Location/City';
import CurrencyRates from '../pages/CurrencyRates';
import AllOrders from '../pages/Orders/All';
import UnpaidOrders from '../pages/Orders/Unpaid';
import ProcessingOrders from '../pages/Orders/Processing';
import PurchasedOrders from '../pages/Orders/Purchased';
import InWarehouseOrders from '../pages/Orders/InWarehouse';
import ShippedOutOrders from '../pages/Orders/ShippedOut';
import InNigeriaOrders from '../pages/Orders/InNigeria';
import ReceievedOrders from '../pages/Orders/Receieved';
import RefundedOrders from '../pages/Orders/Refunded';
import SuccessOrders from '../pages/Orders/Success';
import ClosedOrders from '../pages/Orders/Closed.js';
import PendingApproval from '../pages/Orders/PendingApproval';
import PurchasingReferences from '../pages/Orders/PurchasingReferences';
import TranslateSettings from '../pages/TranslateSettings';
import PlatformTranslations from '../pages/PlatformTranslations';
import SearchHistory from '../pages/SearchHistory';
import APIManagement from '../pages/APIManagement';
import APIKeyManagement from '../pages/APIKeyManagement';
import APIUsageLogs from '../pages/APIUsageLogs';
import APIStatistics from '../pages/APIStatistics';
import PaymentMethod from '../pages/PaymentMethod';
import PaymentDetails from '../pages/PaymentDetails';
import Transaction from '../pages/Transaction';
import InwardTransactionsPage from '../pages/InwardTransactions';
import SystemMessages from '../pages/SystemMessages/index.js';
import InvoiceManagement from '../pages/InvoiceManagement';
import VersionManagement from '../pages/VersionManagement';
import Packages from '../pages/Packages';
import AssistedPackageManagement from '../pages/Packages/Assisted';
import PackagingMaterials from '../pages/PackagingMaterials';
import LogisticsPage from '../pages/Logistics/index.js';
import LogisticsInfoPage from '../pages/Logistics/info.js';
import WithdrawalsPage from '../pages/Withdrawals';
import AccessControl from '../pages/AccessControl';
import RoleManagement from '../pages/RBAC/RoleManagement';
import WalletManagement from '../pages/WalletManagement';
import WalletsPage from '../pages/Wallets';
import BonusManagement from '../pages/BonusManagement';
import DeviceInfo from '../pages/DeviceInfo';
import ProductRequestsPage from '../pages/ProductRequests';
import BannerManagement from '../pages/Banners';
import ManualItemAddPage from '../pages/ManualItemAdd';
import PreOrderCreatePage from '../pages/PreOrderCreate';
import PreOrderManagePage from '../pages/PreOrderManage';
import LocalSupplierItemsPage from '../pages/LocalSupplierItems';
import MarketplaceWarehousePage from '../pages/MarketplaceWarehouse';
import WarehouseLifecycleAdminPage from '../pages/WarehouseLifecycle';
import MarketplaceFulfillmentPage from '../pages/MarketplaceFulfillment';
import AffiliateAdminPage from '../pages/Affiliate';
import AffiliateListPage from '../pages/Affiliate/List';
import AffiliateReferralsPage from '../pages/Affiliate/Referrals';
import ManualAffiliateLinkPage from '../pages/Affiliate/ManualLink';
import AffiliateRankingsPage from '../pages/Affiliate/Rankings';
import BankManagement from '../pages/Bank';
import ExchangeRate from '../pages/RMB/ExchangeRate';
import History from '../pages/RMB/History';
import Transactions from '../pages/RMB/Transactions';
import ProfitAnalytics from '../pages/ProfitAnalytics';
import RMBProfitAnalytics from '../pages/RMBProfitAnalytics';
import MarketingManagers from '../pages/Marketing/Managers';
import CustomerAssignments from '../pages/Marketing/Assignments';
import CommissionTiers from '../pages/Marketing/CommissionTiers';
import Commissions from '../pages/Marketing/Commissions';
import Performance from '../pages/Marketing/Performance';
import ManagerClaim from '../pages/Marketing/Claim';
import AdminManualClaim from '../pages/Marketing/ManualClaim';
import WebsiteAnalytics from '../pages/Marketing/WebsiteAnalytics';
import MarketingAttribution from '../pages/Marketing/Attribution';
import Employees from '../pages/Employees';
import Departments from '../pages/Employees/Departments';
import Positions from '../pages/Employees/Positions';
import LeaveTypes from '../pages/Employees/LeaveTypes';
import LeaveRequests from '../pages/Employees/LeaveRequests';
import Attendance from '../pages/Employees/Attendance';
import Documents from '../pages/Employees/Documents';
import DocumentsUpload from '../pages/Employees/Documents/Upload';
import EmployeeDashboard from '../pages/Employees/Dashboard';
import SalaryStructures from '../pages/Employees/Salary/Structures';
import TaxConfigurations from '../pages/Employees/Salary/Tax/Configurations';
import TaxBrackets from '../pages/Employees/Salary/Tax/Brackets';
import BenefitTypes from '../pages/Employees/Salary/Benefits/Types';
import EmployeeBenefits from '../pages/Employees/Salary/Benefits/EmployeeBenefits';
import Bonuses from '../pages/Employees/Salary/Bonuses';
import SalaryCommissions from '../pages/Employees/Salary/Commissions';
import FAQManagementPage from '../pages/AI/FAQ';
import Fulfillment from '../pages/Fulfillment';
import Cart from '../pages/Cart';
import Checkout from '../pages/Cart/Checkout';
import GroupShippingManagement from '../pages/GroupShipping';
import GroupShippingSettings from '../pages/GroupShipping/Settings';
import GroupBuyActive from '../pages/GroupBuy/Active';
import GroupBuyClosed from '../pages/GroupBuy/Closed';
import GroupBuyPurchased from '../pages/GroupBuy/Purchased';
import GroupBuyInWarehouse from '../pages/GroupBuy/InWarehouse';
import GroupBuyInTransit from '../pages/GroupBuy/InTransit';
import GroupBuyInNigeria from '../pages/GroupBuy/InNigeria';
import GroupBuyFulfilled from '../pages/GroupBuy/Fulfilled';
import GroupBuyCancelled from '../pages/GroupBuy/Cancelled';
import GroupBuyCreate from '../pages/GroupBuy/Create';
import GroupBuyAnalytics from '../pages/GroupBuy/Analytics';
import GroupBuySettings from '../pages/GroupBuy/Settings';
import ExpenseList from '../pages/Expenses';
import ExpenseCreate from '../pages/Expenses/Create';
import ExpenseEditPage from '../pages/Expenses/Edit';
import ExpenseDetail from '../pages/Expenses/Detail';
import AccountingLock from '../pages/Expenses/AccountingLock';
import VirtualAccounts from '../pages/VirtualAccounts';
import ShipmentList from '../pages/Shipments/ShipmentList';
import CreateShipment from '../pages/Shipments/CreateShipment';
import EditShipment from '../pages/Shipments/EditShipment';
import ShipmentDetail from '../pages/Shipments/ShipmentDetail.jsx';
import CarrierManagement from '../pages/Shipments/CarrierManagement';
import SupportChatList from '../pages/SupportChat';
import SupportChatDetail from '../pages/SupportChat/Detail';
import SupportKnowledgePage from '../pages/SupportChat/Knowledge';
import SupportAgentRatingsPage from '../pages/SupportChat/AgentRatings';
import ReviewsAdminPage from '../pages/Reviews';
import ProductAnalytics from '../pages/Products/index.js';
import CategoriesPage from '../pages/Categories';
import BrandManagementPage from '../pages/Brand';
import BrandRequestsPage from '../pages/Brand/request';
import SchemaListPage from '../pages/SchemaList';
import SchemaManagerPage from '../pages/SchemaManager';
import ProductModerationPage from '../pages/ProductModeration';
import ModelManagementPage from '../pages/ModelManagement';
import ModerationConfigPage from '../pages/ModerationConfig';
import AutoApprovalSettingsPage from '../pages/AutoApprovalSettings';
import MerchantsPage from '../pages/Merchants';

const protectedRouteConfigs = [
  { path: '/admin/dashboard', element: <Dashboard /> },
  { path: '/admin/items', element: <Items /> },
  { path: '/admin/items/category', element: <ItemCategories /> },
  { path: '/admin/cart', element: <Cart /> },
  { path: '/admin/cart/checkout', element: <Checkout /> },
  { path: '/admin/group-buy', element: <Navigate to="/admin/group-buy/active" replace /> },
  { path: '/admin/group-buy/active', element: <GroupBuyActive /> },
  { path: '/admin/group-buy/closed', element: <GroupBuyClosed /> },
  { path: '/admin/group-buy/purchased', element: <GroupBuyPurchased /> },
  { path: '/admin/group-buy/in-warehouse', element: <GroupBuyInWarehouse /> },
  { path: '/admin/group-buy/in-transit', element: <GroupBuyInTransit /> },
  { path: '/admin/group-buy/in-nigeria', element: <GroupBuyInNigeria /> },
  { path: '/admin/group-buy/fulfilled', element: <GroupBuyFulfilled /> },
  { path: '/admin/group-buy/cancelled', element: <GroupBuyCancelled /> },
  { path: '/admin/group-buy/create', element: <GroupBuyCreate /> },
  { path: '/admin/group-buy/analytics', element: <GroupBuyAnalytics /> },
  { path: '/admin/group-buy/settings', element: <GroupBuySettings /> },
  { path: '/admin/orders', element: <AllOrders /> },
  { path: '/admin/orders/all', element: <AllOrders /> },
  { path: '/admin/orders/unpaid', element: <UnpaidOrders /> },
  { path: '/admin/orders/processing', element: <ProcessingOrders /> },
  { path: '/admin/orders/purchased', element: <PurchasedOrders /> },
  { path: '/admin/orders/in-warehouse', element: <InWarehouseOrders /> },
  { path: '/admin/orders/shipped-out', element: <ShippedOutOrders /> },
  { path: '/admin/orders/in-nigeria', element: <InNigeriaOrders /> },
  { path: '/admin/orders/receieved', element: <ReceievedOrders /> },
  { path: '/admin/orders/refunded', element: <RefundedOrders /> },
  { path: '/admin/orders/success', element: <SuccessOrders /> },
  { path: '/admin/orders/closed', element: <ClosedOrders /> },
  { path: '/admin/orders/pending-approval', element: <PendingApproval /> },
  { path: '/admin/orders/purchasing-references', element: <PurchasingReferences /> },
  { path: '/admin/packages', element: <Packages /> },
  { path: '/admin/packages/assisted', element: <AssistedPackageManagement /> },
  { path: '/admin/shipments', element: <ShipmentList /> },
  { path: '/admin/shipments/carriers', element: <CarrierManagement /> },
  { path: '/admin/shipments/create', element: <CreateShipment /> },
  { path: '/admin/shipments/:id/edit', element: <EditShipment /> },
  { path: '/admin/shipments/:id', element: <ShipmentDetail /> },
  { path: '/admin/packaging-materials', element: <PackagingMaterials /> },
  { path: '/admin/logistics', element: <LogisticsPage /> },
  { path: '/admin/logistics/info', element: <LogisticsInfoPage /> },
  { path: '/admin/group-shipping', element: <GroupShippingManagement /> },
  { path: '/admin/group-shipping/settings', element: <GroupShippingSettings /> },
  { path: '/admin/invoice-management', element: <InvoiceManagement /> },
  { path: '/admin/users', element: <Users /> },
  { path: '/admin/device-info', element: <DeviceInfo /> },
  { path: '/admin/product-requests', element: <ProductRequestsPage /> },
  { path: '/admin/payment-methods', element: <PaymentMethod /> },
  { path: '/admin/payment-details', element: <PaymentDetails /> },
  { path: '/admin/transactions', element: <Transaction /> },
  { path: '/admin/transactions/inward', element: <InwardTransactionsPage /> },
  { path: '/admin/transactions/topup', element: <Transaction /> },
  { path: '/admin/transactions/withdraw', element: <Transaction /> },
  { path: '/admin/transactions/refund', element: <Transaction /> },
  { path: '/admin/transactions/business', element: <Transaction /> },
  { path: '/admin/transactions/income', element: <Transaction /> },
  { path: '/admin/transactions/transfer', element: <Transaction /> },
  { path: '/admin/transactions/bonus', element: <Transaction /> },
  { path: '/admin/transactions/debit', element: <Transaction /> },
  { path: '/admin/transactions/invoice', element: <Transaction /> },
  { path: '/admin/analytics', element: <Analytics /> },
  { path: '/admin/analytics/user-activity', element: <UserActivityAnalytics /> },
  { path: '/admin/currency-rates', element: <CurrencyRates /> },
  { path: '/admin/settings', element: <Settings /> },
  { path: '/admin/profile', element: <Profile /> },
  { path: '/admin/account-settings', element: <AccountSettings /> },
  { path: '/admin/location/country', element: <Country /> },
  { path: '/admin/location/state', element: <State /> },
  { path: '/admin/location/city', element: <City /> },
  { path: '/admin/translate-settings', element: <TranslateSettings /> },
  { path: '/admin/platform-translations', element: <PlatformTranslations /> },
  { path: '/admin/search-history', element: <SearchHistory /> },
  { path: '/admin/api-management', element: <APIManagement /> },
  { path: '/admin/api-key-management', element: <APIKeyManagement /> },
  { path: '/admin/api-usage-logs', element: <APIUsageLogs /> },
  { path: '/admin/api-statistics', element: <APIStatistics /> },
  { path: '/admin/system-messages', element: <SystemMessages /> },
  { path: '/admin/banners', element: <BannerManagement /> },
  { path: '/admin/manual-item-add', element: <ManualItemAddPage /> },
  { path: '/admin/pre-order/create', element: <PreOrderCreatePage /> },
  { path: '/admin/pre-order/manage', element: <PreOrderManagePage /> },
  { path: '/admin/pre-order/edit/:itemId', element: <PreOrderCreatePage /> },
  { path: '/admin/local-supplier-items', element: <LocalSupplierItemsPage /> },
  { path: '/admin/affiliate', element: <AffiliateAdminPage /> },
  { path: '/admin/affiliate/list', element: <AffiliateListPage /> },
  { path: '/admin/affiliate/rankings', element: <AffiliateRankingsPage /> },
  { path: '/admin/affiliate/referrals', element: <AffiliateReferralsPage /> },
  { path: '/admin/affiliate/manual-link', element: <ManualAffiliateLinkPage /> },
  { path: '/admin/version-management', element: <VersionManagement /> },
  { path: '/admin/rbac/access-control', element: <AccessControl /> },
  { path: '/admin/rbac/roles', element: <RoleManagement /> },
  { path: '/admin/wallet-management', element: <WalletManagement /> },
  { path: '/admin/wallets', element: <WalletsPage /> },
  { path: '/admin/bonus-management', element: <BonusManagement /> },
  { path: '/admin/withdrawals', element: <WithdrawalsPage /> },
  { path: '/admin/banks', element: <BankManagement /> },
  { path: '/admin/rmb/exchange-rate', element: <ExchangeRate /> },
  { path: '/admin/rmb/history', element: <History /> },
  { path: '/admin/rmb/transactions', element: <Transactions /> },
  { path: '/admin/profit-analytics', element: <ProfitAnalytics /> },
  { path: '/admin/rmb-profit-analytics', element: <RMBProfitAnalytics /> },
  { path: '/admin/marketing/managers', element: <MarketingManagers /> },
  { path: '/admin/marketing/assignments', element: <CustomerAssignments scope="admin" /> },
  { path: '/admin/marketing/my-assignments', element: <CustomerAssignments scope="manager" /> },
  { path: '/admin/marketing/manual-claim', element: <AdminManualClaim /> },
  { path: '/admin/marketing/commission-tiers', element: <CommissionTiers /> },
  { path: '/admin/marketing/commissions', element: <Commissions /> },
  { path: '/admin/marketing/performance', element: <Performance /> },
  { path: '/admin/marketing/claim', element: <ManagerClaim /> },
  { path: '/admin/marketing/website-analytics', element: <WebsiteAnalytics /> },
  { path: '/admin/marketing/attribution', element: <MarketingAttribution /> },
  { path: '/admin/employees', element: <Employees /> },
  { path: '/admin/employees/departments', element: <Departments /> },
  { path: '/admin/employees/positions', element: <Positions /> },
  { path: '/admin/employees/leave-types', element: <LeaveTypes /> },
  { path: '/admin/employees/leave-requests', element: <LeaveRequests /> },
  { path: '/admin/employees/attendance', element: <Attendance /> },
  { path: '/admin/employees/documents', element: <Documents /> },
  { path: '/admin/employees/documents/upload', element: <DocumentsUpload /> },
  { path: '/admin/employees/dashboard', element: <EmployeeDashboard /> },
  { path: '/admin/employees/salary/structures', element: <SalaryStructures /> },
  { path: '/admin/employees/salary/tax/configurations', element: <TaxConfigurations /> },
  { path: '/admin/employees/salary/tax/brackets', element: <TaxBrackets /> },
  { path: '/admin/employees/salary/benefits/types', element: <BenefitTypes /> },
  { path: '/admin/employees/salary/benefits/employee-benefits', element: <EmployeeBenefits /> },
  { path: '/admin/employees/salary/bonuses', element: <Bonuses /> },
  { path: '/admin/employees/salary/commissions', element: <SalaryCommissions /> },
  { path: '/admin/ai/faq', element: <FAQManagementPage /> },
  { path: '/admin/fulfillment/*', element: <Fulfillment /> },
  { path: '/admin/fulfillment/service-types', element: <Fulfillment /> },
  { path: '/admin/fulfillment/pricing', element: <Fulfillment /> },
  { path: '/admin/fulfillment/addons', element: <Fulfillment /> },
  { path: '/admin/fulfillment/storage', element: <Fulfillment /> },
  { path: '/admin/fulfillment/requests', element: <Fulfillment /> },
  { path: '/admin/fulfillment/pickup-codes', element: <Fulfillment /> },
  // Expenses
  { path: '/admin/expenses', element: <ExpenseList /> },
  { path: '/admin/expenses/create', element: <ExpenseCreate /> },
  { path: '/admin/expenses/:id/edit', element: <ExpenseEditPage /> },
  { path: '/admin/expenses/:id', element: <ExpenseDetail /> },
  { path: '/admin/expenses/accounting-periods', element: <AccountingLock /> },
  { path: '/admin/support-chat', element: <SupportChatList /> },
  { path: '/admin/support-chat/knowledge', element: <SupportKnowledgePage /> },
  { path: '/admin/support-chat/agent-ratings', element: <SupportAgentRatingsPage /> },
  { path: '/admin/support-chat/:id', element: <SupportChatDetail /> },
  { path: '/admin/virtual-accounts', element: <VirtualAccounts /> },
  { path: '/admin/reviews', element: <ReviewsAdminPage /> },
  { path: '/admin/products', element: <ProductAnalytics /> },
  { path: '/admin/categories', element: <CategoriesPage /> },
  { path: '/admin/brands', element: <BrandManagementPage /> },
  { path: '/admin/brand-requests', element: <BrandRequestsPage /> },
  { path: '/admin/schema', element: <SchemaListPage /> },
  { path: '/admin/schema-manager', element: <SchemaManagerPage /> },
  { path: '/admin/moderation', element: <ProductModerationPage /> },
  { path: '/admin/moderation/model-management', element: <ModelManagementPage /> },
  { path: '/admin/moderation/config', element: <ModerationConfigPage /> },
  { path: '/admin/moderation/auto-approval-settings', element: <AutoApprovalSettingsPage /> },
  { path: '/admin/merchants', element: <MerchantsPage /> },
  { path: '/admin/merchant-admin/warehouses', element: <MarketplaceWarehousePage /> },
  { path: '/admin/merchant-admin/rate-cards', element: <MarketplaceWarehousePage /> },
  { path: '/admin/merchant-admin/storage-accounts', element: <MarketplaceWarehousePage /> },
  { path: '/admin/merchant-admin/inbound-shipments', element: <MarketplaceWarehousePage /> },
  { path: '/admin/merchant-admin/inventory', element: <MarketplaceWarehousePage /> },
  { path: '/admin/merchant-admin/charges', element: <MarketplaceWarehousePage /> },
  { path: '/admin/merchant-admin/invoices', element: <MarketplaceWarehousePage /> },
  { path: '/admin/merchant-admin/fulfillments', element: <MarketplaceFulfillmentPage /> },
  { path: '/admin/merchant-admin/warehouse-lifecycle', element: <WarehouseLifecycleAdminPage /> },
];

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate to="/admin/login" replace />} />
    <Route path="/admin/login" element={<Login />} />
    <Route path="/admin/reset-password" element={<ResetPassword />} />
    <Route path="/admin/access-control" element={<Navigate to="/admin/rbac/access-control" replace />} />
    {protectedRouteConfigs.map(({ path, element }) => (
      <Route
        key={path}
        element={<ProtectedRoute requiredPermissions={getRoutePermissions(path)} />}
      >
        <Route path={path} element={element} />
      </Route>
    ))}
    <Route path="*" element={<NotFound404 />} />
  </Routes>
);

export default AppRoutes; 
